import PropTypes from "prop-types";
import { forwardRef } from "react";
import { Button as ChameleonButton } from "@asosteam/chameleon-button/component";
import "@asosteam/chameleon-button/styles.css";
import {
  ProgressIndicator,
  SIZE_SMALL,
  COLOUR_SCHEME_INVERTED,
} from "@asosteam/asos-web-component-library-progress-indicator";

// ATOM GAP (extension: Button.loading) — no native loading state; composed with the legacy ProgressIndicator per playbook gap-button-loading
export const Button = forwardRef(
  ({ isInProgress, loadingLabel, disabled, children, ...props }, ref) => (
    <ChameleonButton
      ref={ref}
      disabled={disabled || isInProgress}
      {...props}
      // ProgressIndicator is always aria-hidden, so the label must live on the button
      {...(isInProgress && loadingLabel ? { "aria-label": loadingLabel } : {})}
    >
      {isInProgress ? (
        <ProgressIndicator
          size={SIZE_SMALL}
          colourScheme={COLOUR_SCHEME_INVERTED}
          progressMessage={loadingLabel}
        />
      ) : (
        children
      )}
    </ChameleonButton>
  )
);

Button.displayName = "Button";

Button.propTypes = {
  isInProgress: PropTypes.bool,
  loadingLabel: PropTypes.string,
  disabled: PropTypes.bool,
  children: PropTypes.node,
};

Button.defaultProps = {
  isInProgress: false,
  loadingLabel: "",
  disabled: false,
};
